import requestPermissionsOnAlexa from './requestPermissionsOnAlexa';

export default requestPermissionsOnAlexa;
